<template>
  <section
    class="rounded-lg border border-gray-200 bg-white p-4 md:p-5"
    data-cy="import-results"
  >
    <div class="grid gap-4 md:grid-cols-2">
      <div v-if="results.processing" data-cy="import-results-processing">
        <ProcessingDatasetTable :processing="results.processing" />
      </div>
      <div data-cy="import-results-counts">
        <ResultsDatasetTable :results="results.results" />
      </div>
    </div>

    <div v-if="detailCount" class="mt-3">
      <ExpandButton
        :title="`${showDetails ? 'Hide' : 'View'} Details (${detailCount})`"
        :expanded="showDetails"
        data-cy="import-results-expand"
        @toggle-expanded="showDetails = !showDetails"
      />
      <DetailsDatasetTable
        v-if="showDetails"
        class="mt-3"
        :details="results.details"
        data-cy="import-results-details"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import ExpandButton from "@/components/ExpandButton.vue";
import DetailsDatasetTable from "@/DataImports/DetailsDatasetTable.vue";
import type { ImportResults } from "@/DataImports/importsHubRows";
import ProcessingDatasetTable from "@/DataImports/ProcessingDatasetTable.vue";
import ResultsDatasetTable from "@/DataImports/ResultsDatasetTable.vue";

// The old batch card's tables, so labels and numbers match it.
const props = defineProps<{
  results: ImportResults & { results: Record<string, number> };
}>();

const showDetails = ref(false);
const detailCount = computed(
  () => Object.keys(props.results.details ?? {}).length
);
</script>
